import { getUserObjData } from '@common/services/cookies.service'
import axios, { AxiosInstance, AxiosResponse } from 'axios'

const AxiosInterceptorInstanceFd: AxiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_FD_LEAD_BACKEND_URL,
  withCredentials: true
})

const successStatusCodes: number[] = [200, 202, 201]

// Request interceptor
AxiosInterceptorInstanceFd.interceptors.request.use(
  (config: any) => {
    const lang = getUserObjData('x-lang')
    const headers: any = {
      'x-lang': lang,
      'x-platform': 'web'
    }

    if (config.headers) {
      config.headers = { ...config.headers, ...headers }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
AxiosInterceptorInstanceFd.interceptors.response.use(
  (response: AxiosResponse) => {
    if (successStatusCodes.indexOf(response.status) > -1) {
      return response.data
    } else {
      throw new Error(response.data.message || `Request failed with status ${response.status}`)
    }
  },
  (error) => {
    console.log(error)
    return Promise.reject({
      status: error?.response?.status,
      message: error?.response?.data.message
    })
  }
)
// End of Response interceptor

export default AxiosInterceptorInstanceFd
